import { Injectable, OnDestroy } from '@angular/core';
import { Subject, BehaviorSubject, fromEvent } from 'rxjs';
import { takeUntil, debounceTime } from 'rxjs/operators';
import { Router } from '@angular/router';

// Keep existing Menu interface
export interface Menu {
  headTitle?: string;
  headTitle2?: string;
  path?: string;
  dirchange?: boolean;
  title?: string;
  icon?: string;
  type?: string;
  badgeValue?: string;
  badgeClass?: string;
  active?: boolean;
  selected?: boolean;
  bookmark?: boolean;
  children?: Menu[];
  Menusub?: boolean;
  target?: boolean;
  menutype?: string;
}

@Injectable({
  providedIn: 'root',
})
export class NavService implements OnDestroy {
  private unsubscriber: Subject<any> = new Subject();
  public screenWidth: BehaviorSubject<number> = new BehaviorSubject(window.innerWidth);

  // Search Box
  public search = false;

  // Language
  public language = false;

  // Mega Menu
  public megaMenu = false;
  public levelMenu = false;
  public megaMenuColapse: boolean = window.innerWidth < 1199 ? true : false;

  // Collapse Sidebar
  public collapseSidebar: boolean = window.innerWidth < 991 ? true : false;

  // For Horizontal Layout Mobile
  public horizontal: boolean = window.innerWidth < 991 ? false : true;

  // Full screen
  public fullScreen = false;
  active: any;

  // Default menu items - fallback when modules service is not available
  private defaultMenuItems: Menu[] = [
    // Dashboard
    { headTitle: 'MAIN' },
    {
      title: 'Dashboards',
      icon: `<svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 side-menu__icon" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" /></svg>`,
      dirchange: false,
      type: 'sub',
      active: false,
      children: [
        {
          title: 'Sales',
          dirchange: false,
          type: 'link',
          active: false,
          selected: false,
          path: '/dashboards/sales',
        },
      ],
    },
    // User management
    {
      title: 'User Management',
      icon: `<svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 side-menu__icon" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" /></svg>`,
      dirchange: false,
      type: 'sub',
      active: false,
      children: [
        {
          title: 'Access Control',
          dirchange: false,
          type: 'link',
          active: false,
          selected: false,
          path: '/user-management/access-control',
        },
        {
          title: 'Staff Directory',
          dirchange: false,
          type: 'link',
          active: false,
          selected: false,
          path: '/user-management/staff-directory',
        },
      ],
    },
    {
      title: 'Nested Menu',
      icon: `<svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 side-menu__icon" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
    </svg>`,
      dirchange: false,
      type: 'sub',
      active: false,
      children: [
        {
          title: 'Nested-1',
          dirchange: false,
          type: 'empty',
          active: false,
          selected: false,
          path: '/nested-menu/nested-1',
        },
        {
          title: 'Nested-2',
          dirchange: false,
          type: 'sub',
          selected: false,
          children: [
            {
              title: 'Nested-2.1',
              dirchange: false,
              type: 'empty',
              active: false,
              selected: false,
              path: '/nested-menu/nested-2/nested-2-1',
            },
            {
              title: 'Nested-2.2',
              dirchange: false,
              type: 'empty',
              active: false,
              selected: false,
              path: '/nested-menu/nested-2/nested-2-2',
            },
          ],
        },
      ],
    },
    // authentication
    { headTitle: 'PAGES' },
    {
      title: 'Error',
      icon: `<svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 side-menu__icon" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
    </svg>`,
      dirchange: false,
      type: 'sub',
      active: false,
      children: [
        {
          title: 'Error 404',
          dirchange: false,
          type: 'link',
          active: false,
          selected: false,
          path: '/error/error404',
        },
      ],
    },
  ];

  // Array - keep existing property name for backward compatibility
  private itemsSubject = new BehaviorSubject<Menu[]>(this.defaultMenuItems);
  public items = this.itemsSubject.asObservable();

  // Keep MENUITEMS for backward compatibility (getter)
  get MENUITEMS(): Menu[] {
    return this.itemsSubject.getValue();
  }

  constructor(private router: Router) {
    this.setScreenWidth(window.innerWidth);
    fromEvent(window, 'resize')
      .pipe(debounceTime(1000), takeUntil(this.unsubscriber))
      .subscribe((evt: any) => {
        this.setScreenWidth(evt.target.innerWidth);
        if (evt.target.innerWidth < 991) {
          this.collapseSidebar = true;
          this.megaMenu = false;
          this.levelMenu = false;
        }
        if (evt.target.innerWidth < 1199) {
          this.megaMenuColapse = true;
        }
      });
    if (window.innerWidth < 991) {
      // Detect Route change sidebar close
      this.router.events.subscribe((event) => {
        this.collapseSidebar = true;
        this.megaMenu = false;
        this.levelMenu = false;
      });
    }
  }

  ngOnDestroy() {
    this.unsubscriber.next;
    this.unsubscriber.complete();
  }

  private setScreenWidth(width: number): void {
    this.screenWidth.next(width);
  }

  /**
   * Update menu items (used by modules service)
   */
  updateMenuItems(items: Menu[]): void {
    this.itemsSubject.next(items);
  }

  /**
   * Get current menu items
   */
  getCurrentMenuItems(): Menu[] {
    return this.itemsSubject.getValue();
  }

  /**
   * Add a new menu item
   */
  addMenuItem(item: Menu, position?: number): void {
    const currentItems = this.getCurrentMenuItems();

    if (position !== undefined && position >= 0 && position <= currentItems.length) {
      currentItems.splice(position, 0, item);
    } else {
      currentItems.push(item);
    }

    this.itemsSubject.next([...currentItems]);
  }

  /**
   * Remove a menu item by path
   */
  removeMenuItem(path: string): void {
    const currentItems = this.getCurrentMenuItems();
    const filteredItems = this.removeMenuItemRecursive(currentItems, path);
    this.itemsSubject.next(filteredItems);
  }

  private removeMenuItemRecursive(items: Menu[], path: string): Menu[] {
    return items.filter((item) => {
      if (item.path === path) {
        return false;
      }

      if (item.children) {
        item.children = this.removeMenuItemRecursive(item.children, path);
      }

      return true;
    });
  }

  /**
   * Set active menu item by path
   */
  setActiveMenuItem(path: string): void {
    const currentItems = this.getCurrentMenuItems();
    this.clearAllActive(currentItems);
    this.setActiveRecursive(currentItems, path);
    this.itemsSubject.next([...currentItems]);
  }

  private clearAllActive(items: Menu[]): void {
    items.forEach((item) => {
      item.active = false;
      item.selected = false;
      if (item.children) {
        this.clearAllActive(item.children);
      }
    });
  }

  private setActiveRecursive(items: Menu[], path: string): boolean {
    for (const item of items) {
      if (item.path === path) {
        item.active = true;
        item.selected = true;
        return true;
      }

      if (item.children && this.setActiveRecursive(item.children, path)) {
        item.active = true;
        return true;
      }
    }
    return false;
  }

  /**
   * Reset to default menu items
   */
  resetToDefaultMenu(): void {
    this.itemsSubject.next([...this.defaultMenuItems]);
  }
}
